import React, { useState } from "react";
import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";
import "./Members.css";

const bigImages = [
  //...左侧图片
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure1.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure2.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure3.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure4.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure5.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure6.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure7.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure8.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure9.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure10.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure11.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure12.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure13.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure14.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure15.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure16.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure17.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure18.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure19.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure20.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure21.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure22.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure23.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure24.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure25.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure26.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure27.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure28.png",
  "https://static.igem.wiki/teams/4826/wiki/members-big-figure29.png",
];

const smallImages = [
  //...右侧图片
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure1.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure2.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure3.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure4.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure5.png",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure6.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure7.png",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure8.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure9.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure10.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure11.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure12.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure13.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure14.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure15.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure16.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure17.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure18.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure19.png",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure20.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure21.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure22.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure23.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure24.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure25.png",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure26.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure27.jpg",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure28.png",
  "https://static.igem.wiki/teams/4826/wiki/members-small-figure29.jpg",
];

export default function Members() {
  const [displayImg, setDisplayImg] = useState(
    "https://static.igem.wiki/teams/4826/wiki/printing.svg"
  );

  const changeImage = (index) => {
    setDisplayImg(bigImages[index]);
  };

  function Image({ img, index, onClick: handleClick }) {
    // 控制蒙版显示状态
    const [masked, setMasked] = useState(false);

    const toggleMasked = () => {
      setMasked((prev) => !prev);
    };

    const imgClass = "small-image";

    return (
      <img
        className={`${imgClass} ${masked ? "masked" : ""}`}
        src={img}
        alt={img}
        onClick={() => {
          toggleMasked();
          handleClick(index);
        }}
      />
    );
  }

  return (
    <div className="general-background">
      <NavigationBar />
      <div className="main-container">
        <p className="title">Team Members</p>
        <p className="subtitle" style={{ paddingTop: 0 }}>
          · Heartfelt thanks to every member of a team effort.
        </p>
        <div className="card-container">
          <div className="card-left">
            <img src={displayImg} alt="printing" className="printing" />
          </div>
          <div className="card-right">
            <div className="card-right-text">
              <p>Click to view the personal page</p>
            </div>
            <div className="card-right-photo">
              {smallImages.map((img, index) => (
                <Image
                  key={index}
                  img={img}
                  index={index}
                  onClick={changeImage}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
